import React, { useEffect, useState } from "react";
import { Box, Grid, Tab, Tabs, Typography } from "@material-ui/core";

import DialogComponent from "../../components/Dialog";
import { Get } from "../../actions";
import { Get_CronJobCustomers_URL } from "../../constants/apiUrls";
import { getTranslation } from "../../heplers/translationHelper";
import { format } from "../../heplers/format";
import CronJobCustomers from "./CronJobCustomers";
import CronJobRuns from "./CronJobRuns";
import CronJobLogs from "./CronJobLogs";

/**
 * Everything known about one cron job, in the order the questions get asked: which customers is it
 * healthy for, what happened on each trigger, and what did the run write to the log.
 */
const CronJobDetailsDialog = ({ cronJob, levels, onClose }) => {
  const [tab, setTab] = useState(0);
  const [customerId, setCustomerId] = useState("");
  const [customers, setCustomers] = useState([]);

  // Fetched once for the customer dropdowns on the Runs and Logs tabs, so those tabs do not depend
  // on whatever filter the Customers tab happens to have applied.
  useEffect(() => {
    if (!cronJob?.id) return;

    Get(
      { id: cronJob.id, days: 90 },
      Get_CronJobCustomers_URL,
      null,
      (resp) => setCustomers(resp?.data?.customers ?? []),
      () => {}
    );
  }, [cronJob?.id]);

  const openCustomer = (customer) => {
    setCustomerId(customer.customerId);
    setTab(1);
  };

  return (
    <DialogComponent
      open={Boolean(cronJob)}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      title={`${cronJob?.appName} / ${cronJob?.route}`}
    >
      <Box pb={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Typography variant="body2">
              <b>{getTranslation("Type", "Type", "Typ")}:</b>{" "}
              {cronJob?.executionName}
            </Typography>
            <Typography variant="body2">
              <b>{getTranslation("Status", "Statut", "Status")}:</b>{" "}
              {cronJob?.isActive
                ? getTranslation("Active", "Actif", "Aktiv")
                : getTranslation("Disabled", "Désactivé", "Deaktiviert")}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="body2">
              <b>{getTranslation("URL", "URL", "URL")}:</b>{" "}
              {cronJob?.effectiveBaseUrl || "-"}
            </Typography>
            <Typography variant="body2">
              <b>
                {getTranslation("Last run", "Dernière exécution", "Letzter Lauf")}:
              </b>{" "}
              {cronJob?.lastRunAt
                ? `${format("dateTime", cronJob.lastRunAt)} (${
                    cronJob.lastRunStatusName
                  })`
                : "-"}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="body2">
              <b>
                {getTranslation(
                  "Last result",
                  "Dernier résultat",
                  "Letztes Ergebnis"
                )}
                :
              </b>{" "}
              {cronJob?.lastRunMessage || "-"}
            </Typography>
          </Grid>
        </Grid>

        <Box mt={2} mb={2}>
          <Tabs
            value={tab}
            onChange={(e, value) => setTab(value)}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label={getTranslation("Customers", "Clients", "Kunden")} />
            <Tab label={getTranslation("Runs", "Exécutions", "Läufe")} />
            <Tab label={getTranslation("Logs", "Journaux", "Protokolle")} />
          </Tabs>
        </Box>

        {tab === 0 ? (
          <CronJobCustomers cronJob={cronJob} onOpenCustomer={openCustomer} />
        ) : null}

        {tab === 1 ? (
          <CronJobRuns
            cronJob={cronJob}
            customerId={customerId}
            customers={customers}
            onChangeCustomer={setCustomerId}
          />
        ) : null}

        {tab === 2 ? (
          <CronJobLogs
            cronJob={cronJob}
            levels={levels}
            customerId={customerId}
            customers={customers}
            onChangeCustomer={setCustomerId}
          />
        ) : null}
      </Box>
    </DialogComponent>
  );
};

export default CronJobDetailsDialog;
